import { globalConstants, serverResponseConstants } from "../constants";
import { userActions } from "../redux/actions";
import { ToastifyService, userService } from "../services";
import { GLOBAL_STATUS } from "./global-enums";
import { clearStorage } from "./storage";

const {
  NETWORK_ERROR,
  SERVER_ISSUE,
  UNAUTHORIZE_ACCESS,
  SOMETHING_WENT_WRONG,
} = serverResponseConstants;

//Retrieves all error messages from an object of errors.
function allErrorMessages(errors) {
  let errorMessages = [];
  // eslint-disable-next-line
  Object.keys(errors).forEach((key) => {
    errorMessages.push(errors[key]);
  });
  console.log("errorMessages",errorMessages);
  return errorMessages;
}

//Handle responses by the status
function handleResponseByStatus(response) {
  return response.text().then((text) => {
    const data = text && JSON.parse(text);
      console.log("status",response.status);
    if (response.status === GLOBAL_STATUS.UNAUTHORIZED) {
      //Auto logout if 401 response returned from api
      userService.logout().then(window.location.assign("/"));
    }
    const error = (data?.message) || response.statusText;
    return Promise.reject(error);
  });
}

//Handle the server responses request
function handleServerResponse(response) {
  const { status, data } = response;
  if(status === GLOBAL_STATUS.BAD_REQUEST)
  {
    return Promise.reject(data?.message || response);
  }
  if (
    status === GLOBAL_STATUS.SUCCESS ||
    status === GLOBAL_STATUS.NON_AUTHORITATIVE ||
    status === GLOBAL_STATUS.NO_CONTENT
  ) {
    return data?.payload || data;
  } else if (status === GLOBAL_STATUS.UNAUTHORIZED) {
     clearStorage();
      window.location.href = '/'
  }
  return Promise.reject(response);
}

//Handle the mark responses to return in payload
function handleMarkServerResponse(response) {
  const { payload } = response.data;
  return payload;
}

//Handling the blob responses to return there responses in text form
async function handleBlobResponse(response) {
  await response.data.text().then((text) => {
    return text;
  });
}

//Function to handle http response from server and perform action accordingly
function handleHTTPResponses(httpResponse) {
  let errorMessages = [];
  if (httpResponse) {
    const { message } = httpResponse.data;
    if (message === globalConstants.NETWORK_ERROR) {
      errorMessages.push(SERVER_ISSUE);
      return Promise.reject(errorMessages);
    }
    if (message === UNAUTHORIZE_ACCESS) {
      userActions.clearUserData();
    }
    const responseStatus = httpResponse.status;
    if (responseStatus !== GLOBAL_STATUS.SUCCESS) {
      if (
        responseStatus === GLOBAL_STATUS.UNAUTHORIZED ||
        responseStatus === GLOBAL_STATUS.FORBIDDEN
      ) {
        setTimeout(() => {
          clearStorage();
          window.location.href = '/'
        }, 1000);
      }
      if (httpResponse.data.errors) {
        errorMessages = allErrorMessages(httpResponse.data.errors);
      }
      errorMessages.unshift(message);
      errorMessages = errorMessages.filter((x) => x);
      return Promise.reject(errorMessages);
    }
    return httpResponse;
  }
  errorMessages.push(SERVER_ISSUE);
  return Promise.reject(errorMessages);
}


//Response handler constants
const responseHandler = {
  handleResponseByStatus,
  handleServerResponse,
  handleMarkServerResponse,
  handleBlobResponse,
  handleHTTPResponses
};

export default responseHandler;
